import React, {Component} from 'react';
import ReactSpeedometer from "react-d3-speedometer";


class Tacho extends Component {
    render() {

        let rot = parseInt(this.props.rotationSpeed, 10);
        if (rot > 1200) rot = 1200;
        if (rot < 0) rot = 0;

        return (
            <div className={"speed"} style={{left: '-30px'}}>
                {/*<img src={require("../img/dashboard/tacho-mini.svg").default} alt="RPM"/>*/}

                <ReactSpeedometer
                    width={160}
                    height={150}

                    minValue={0}
                    maxValue={1200}
                    startColor={'#a0a0a0'}
                    endColor={'#e0e0e0'}
                    needleColor={'#fff'}
                    value={rot}
                    textColor={'#fff'}
                    needleTransitionDuration={1500}
                    ringWidth={15}
                    segments={6}
                    needleTransition={'easeSinInOut'}
                />
            </div>
        );
    }
}

export default Tacho;